// Update Assignment
export const UPDATE_ASSIGNMENT_REQUEST = 'UPDATE_ASSIGNMENT_REQUEST';
export const UPDATE_ASSIGNMENT_DONE = 'UPDATE_ASSIGNMENT_DONE';
export const UPDATE_ASSIGNMENT_FAILED = 'UPDATE_ASSIGNMENT_FAILED';
export const UPDATE_ASSIGNMENT_CLEAR_ERRORS = 'UPDATE_ASSIGNMENT_CLEAR_ERRORS';
export const UPDATE_ASSIGNMENT_RESET = 'UPDATE_ASSIGNMENT_RESET';